import $ from 'jquery';

window.jQuery = $;

$('document').ready(() => {});



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/lib.js